__turbopack_context__.v({
  "configureButton": "uD-aDa_configureButton",
  "configureButtonIcon": "uD-aDa_configureButtonIcon",
  "configureButtonText": "uD-aDa_configureButtonText",
  "description": "uD-aDa_description",
  "iconCircle": "uD-aDa_iconCircle",
  "liveOffIcon": "uD-aDa_liveOffIcon",
  "message": "uD-aDa_message",
  "panel": "uD-aDa_panel",
  "root": "uD-aDa_root",
  "text": "uD-aDa_text",
  "title": "uD-aDa_title",
});
